import React from 'react';
import Slider from 'react-slick';
import './hb.css';

import adithyaLogo from "../Assets/hs1.png"
import kamalaLogo from "../Assets/hs2.png"
import novacareLogo from "../Assets/hs3.png"
 
function HospitalBackend() {
    const hospitals = [
        { name: 'SHRI ADITHYA Hospitals', logo: adithyaLogo },
        { name: 'SRESHTA SRI KAMALA HOSPITALS', logo: kamalaLogo },
        { name: 'NOVACARE HOSPITALS', logo: novacareLogo },
     ];

    const settings = {
        dots: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: { slidesToShow: 3 }
            },
             {
                breakpoint: 768,
                settings: { slidesToShow: 3 }
            },
            {
                breakpoint: 480,
                settings: { slidesToShow: 2 }
            },            {
                breakpoint: 340,
                settings: { slidesToShow: 1 }
            }

            
        ]
    };

    return (
        <div className='hb-container'>
            <div className='hb'>
                <h2>Hospital-Backed. Home-Powered.</h2>
                <p>
                    Wihan bridges hospitals and homes by enabling a smooth transition of care post discharge. <br />
                    We partner with top tier hospitals to ensure timely, and reliable post-hospital care.
                </p>
                <Slider {...settings}>
                    {hospitals.map((hospital, index) => (
                        <div key={index} className="hospital-card">
                            <img src={hospital.logo} alt={hospital.name} />
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
}

export default HospitalBackend;
